import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AmountDirective } from '../../directives/amount.directive';
import { CardExpiryDirective } from '../../directives/card-exp.directive';
import { DigitsOnlyDirective } from '../../directives/digits-only.directive';
import { MaxLengthDirective } from '../../directives/max-length.directive';
import { NoInputDirective } from '../../directives/no-input.directive';
import { CardNumberDirective } from '../../directives/card-number.directive';
import { DecimalDirective } from '../../directives/decimal.directive';

@Component({
  selector: 'app-input',
  imports: [
    ReactiveFormsModule,
    NgClass,
    AmountDirective,
    DigitsOnlyDirective,
    MaxLengthDirective,
    // CardExpiryDirective,
    // CardNumberDirective,
    NoInputDirective,
    DecimalDirective,
  ],
  templateUrl: './input.html',
  styleUrl: './input.scss',
})
export class InputComponent implements OnChanges {
  // Directives
  @Input({ alias: 'decimal' }) decimal: boolean = false;
  @Input({ alias: 'amount' }) amount: boolean = false;
  @Input({ alias: 'digitsOnly' }) digitsOnly: boolean = false;
  @Input({ alias: 'maxLength' }) maxLength: number = 0;
  @Input({ alias: 'cardExpiry' }) cardExpiry: boolean = false;
  @Input({ alias: 'cardNumber' }) cardNumber: boolean = false;
  @Input({ alias: 'noInput' }) noInput: boolean = false;
  @Input({ alias: 'maxValue' }) maxValue: number | null = null;
  @Input({ alias: 'minValue' }) minValue: number | null = null;
  @Input({ alias: 'step' }) step: number | null = null;

  @Input({ alias: 'control' }) control!: FormControl;
  @Input({ alias: 'inputClass' }) inputClass: string = '';
  @Input({ alias: 'label' }) label: string = '';
  @Input({ alias: 'labelClass' }) labelClass: string = '';
  @Input({ alias: 'secondaryLabel' }) secondaryLabel: string = '';
  @Input({ alias: 'type' }) type:
    | 'text'
    | 'password'
    | 'email'
    | 'tel'
    | 'url'
    | 'number' = 'text';
  @Input({ alias: 'errorMessage' }) errorMessage?: string;
  @Input({ alias: 'useDefaultError', transform: booleanAttribute })
  useDefaultError: boolean = true;
  @Input({ alias: 'placeholder' }) placeholder: string = '';
  @Input({ alias: 'id' }) id: string = '';
  @Input({ alias: 'autocomplete' }) autocomplete: string = '';
  @Input({ alias: 'autofocus', transform: booleanAttribute })
  autofocus: boolean = false;
  @Input({ alias: 'showPrefix' }) showPrefix: boolean = false;
  @Input({ alias: 'showSuffix' }) showSuffix: boolean = false;
  /**
   * Renders the field non-editable while keeping it focusable, copyable and
   * part of `form.value`/validity — unlike `disabled`, which drops the control
   * from both and removes it from the tab order.
   */
  @Input({ alias: 'readonly', transform: booleanAttribute })
  isReadonly: boolean = false;
  /** Id of an element describing this field, e.g. an aria-live status line. */
  @Input({ alias: 'describedBy' }) describedBy: string = '';
  @Output() focus = new EventEmitter();
  @Output() blur = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (this.useDefaultError && (changes['label'] || !this.errorMessage)) {
      this.errorMessage = `Invalid ${
        this.label || 'input'
      }. Please check your entries and try again.`;
    }
  }

  onFocus(event: any) {
    this.focus.emit(event);
  }

  onBlur(event: any) {
    this.blur.emit(event);
  }
}
